import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { formatDisplayNumber } from '@/utils/number'
import { formatDisplayDate } from '@/utils/date'

export const listMixin = {
  data() {
    return {
      apiUrl: undefined,
      totalItems: 0
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    listHeaders() {
      let result = []
      for (const selectedColumn of this.selectedColumns) {
        let findCol = this.columns.find(a => selectedColumn === a.value)
        if (findCol) {
          result.push(findCol)
        }
      }
      result.push(TableConst.tableActionHeader)
      return result
    }
  },
  methods: {
    formatNumber(xNum) {
      return formatDisplayNumber(xNum)
    },
    formatDate(xDate) {
      return formatDisplayDate(xDate)
    },
    formatBoolean(xBoolean) {
      return xBoolean ? 'Yes' : 'No'
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
